import md5 from '@/assets/js/md5.min.js'

const encodePwd = function(pwd, ts) {
    if (ts) {
        return md5(ts + md5(pwd).toUpperCase()).toUpperCase();
    } else {
        return md5(pwd).toUpperCase();
    }
}

export default {
  encodePwd
}
